import "react-responsive-modal/styles.css";
import "./style.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import request from "../../shared/utils/request";
import { useState, useRef, useEffect } from "react";
import { Modal } from "react-responsive-modal";
import { ModalHeading } from "../../shared/components/modalHeading";
import { LoadingButton } from "../../shared/components/loadingButton";
import { Editor } from "@tinymce/tinymce-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const CreateVocabulary = ({
  open,
  onCloseModal,
  vocabularyData,
  getDatas,
}) => {
  const editorRef = useRef(null);
  const [loader, setLoader] = useState(false);

  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      id: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Note title is required"),
      description: Yup.string().required("Description is required"),
    }),
    onSubmit: async (values) => {
      try {
        setLoader(true);
        let response = null;
        if (vocabularyData) {
          values.id = vocabularyData.id;
          response = await request.put("student/updateVocabulary", values);
        } else {
          response = await request.post("student/createVocabulary", values);
        }
        toast.success(response?.data?.message, {
          autoClose: 4000,
        });
        onCloseModal();
        getDatas();
        formik.resetForm();
        setLoader(true);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoader(false);
      }
    },
  });

  useEffect(() => {
    console.log("vocabularyData", vocabularyData);
    if (vocabularyData) {
      formik.setFieldValue("title", vocabularyData.title);
      formik.setFieldValue("description", vocabularyData.description);
    } else {
      formik.setFieldValue("title", "");
      formik.setFieldValue("description", "");
    }
  }, [vocabularyData]);

  return (
    <div>
      <Modal
        open={open}
        onClose={() => {
          formik.resetForm();
          onCloseModal();
        }}
        center
        styles={{ modal: { minWidth: "95%" } }}
      >
        <div className="note-card">
          <ModalHeading heading={"Add New Note"} />
          <div className="card-body p-4">
            <form onSubmit={formik.handleSubmit} className="note-form">
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control eduform"
                  id="title"
                  placeholder="Note Title"
                  {...formik.getFieldProps("title")}
                />
              </div>
              <div className="mb-3">
                <Editor
                  apiKey={process.env.REACT_APP_EDITOR_KEY}
                  onInit={(_evt, editor) => (editorRef.current = editor)}
                  value={formik.values.description}
                  init={{
                    height: 500,
                    menubar: true,
                    plugins: [
                      "advlist",
                      "autolink",
                      "lists",
                      "link",
                      "image",
                      "charmap",
                      "preview",
                      "anchor",
                      "searchreplace",
                      "visualblocks",
                      "code",
                      "fullscreen",
                      "insertdatetime",
                      "media",
                      "table",
                      "code",
                      "help",
                      "wordcount",
                    ],
                    toolbar:
                      "undo redo | blocks | " +
                      "bold italic forecolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help", // Add LTR/RTL buttons
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                  }}
                  name="description"
                  onEditorChange={(content) =>
                    formik.setFieldValue("description", content)
                  }
                />
              </div>
              <div className="row g-3 align-items-center">
                <div className="col text-end">
                  <LoadingButton
                    isLoading={loader}
                    buttonText={"Save"}
                    customClass={"btn btn-primary create-btn"}
                    disabled={!formik.isValid}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </div>
  );
};
